var bigInt = require("big-integer");

function convertBase(value, from_base, to_base) {
  var range = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ+/'.split('');
  var from_range = range.slice(0, from_base);
  var to_range = range.slice(0, to_base);

  let dec_value = bigInt(value, from_base);

  var new_value = '';
  while (dec_value > 0) {
    new_value = to_range[dec_value.mod(to_base)] + new_value;
    dec_value = (dec_value.minus((dec_value.mod(to_base)))).divide(to_base);
  }
  return new_value || '0';
}

function encode(list){
  let binURL = ''

  list.forEach((objectID) => {
    let objectIDToBinary = convertBase(String(objectID), 10, 2)
    objectIDToBinary = ('00000000' + objectIDToBinary).slice(-9)
    binURL = binURL + objectIDToBinary
  })

  let b64URL = convertBase(binURL, 2, 36)
  return b64URL;
}

function decode(query){
  let items = [];

  if (query != null && query !='') {

    try {

     query = convertBase(query,36,2);
     let lenQuery = query.split('').length;
     let extraStr = '';

     while (lenQuery%9!=0){
       extraStr = extraStr + '0';
       lenQuery++
     }

     query = query.replace (/^/,extraStr);

     let queryUnpacked = query.match(/(.{9})/g);

    const queryItems = queryUnpacked.map((item,index) =>{
      let itemId = convertBase(item,2,10)
      items.push(Number(itemId));
    });

    } catch (error) {
      items = [];
    }

  }

    return items;
}


export { encode, decode }
